import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const ButtonComponent = (props) => {
    const { onClick, loading, title,style} = props;
    return (
        <Button style={style || { width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%',borderRadius:'10px' }} variant="contained" onClick={onClick} disabled={loading}>
            {loading && <CircularProgress  style={{color:'#ffffff'}} size={25} />}
            {!loading &&  `${title}`}
        </Button>
    );
}

export default ButtonComponent;
